import { useEffect, useState } from "react";
import axios from "axios";

export function useConfig() {
    const [config, setConfig] = useState(null);
    useEffect(() => {
        axios
            .get(`${process.env.REACT_APP_BACKEND_URL}/api/config`)
            .then((r) => setConfig(r.data))
            .catch(() => {});
    }, []);
    return config;
}
